
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as mapNhrrvTKaWPKjMdOEbyu1WuZ2MiNApyPENzwng5fwrWcMeta } from "/app/pages/map.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as _91id_93qBti8T_8g7L_bgvS2RsNoHucR8tLtbz12cjslL7jGLMMeta } from "/app/pages/posts/[id].vue?macro=true";
import { default as _91id_93_45_91slug_93ECFhBO0l_45xZDaVNOjCMJTEScpgNgv77ZwG35z49_45nQkMeta } from "/app/pages/itinerari/[id]-[slug].vue?macro=true";
export default [
  {
    name: "map",
    path: "/map",
    component: () => import("/app/pages/map.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "posts-id",
    path: "/posts/:id()",
    component: () => import("/app/pages/posts/[id].vue")
  },
  {
    name: "itinerari-id-slug",
    path: "/itinerari/:id()-:slug()",
    meta: _91id_93_45_91slug_93ECFhBO0l_45xZDaVNOjCMJTEScpgNgv77ZwG35z49_45nQkMeta || {},
    component: () => import("/app/pages/itinerari/[id]-[slug].vue")
  }
]